import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Segment } from '../../../../services/analytics-services/segment';
import Global from '../../../../store/global-selectors';
import {
  SUBSCRIPTION_CHANGE_START,
  SUBSCRIPTION_CHANGE_COMPLETE,
  SUBSCRIPTION_CHANGE_ERROR,
  SUBSCRIPTION_CHANGE_SELECT_PLAN,
  SUBSCRIPTION_CHANGE_COMPARE_FEATURES_CLICK,
  SUBSCRIPTION_MIGRATION_TAB_SWITCH,
  ANNUAL_BILLING_TOGGLE,
  ADD_USER_CLICK,
  ADD_USER_CLICK_CONFIRM,
  FUND_SHIPSURANCE_CLICK,
  CONFIRM_FUND_SHIPSURANCE_CLICK,
  FUND_WALLET_CLICK,
  CONFIRM_FUND_WALLET_CLICK,
  MANAGE_AUTOFUND_CONFIG_CLICK,
  MANAGE_AUTOFUND_CONFIG_SAVE,
  UDPATE_RECURLY_BILLING_CLICK,
  UPDATE_RECURLY_BILLING_SAVE,
  UDPATE_WALLET_BILLING_CLICK,
  UPDATE_WALLET_BILLING_SAVE,
  ADD_VAT_ID_CLOSE,
  ADD_VAT_ID_CLICKED,
  ADD_VAT_ID_COMPLETE,
  ADD_VAT_ID_ERROR,
  SUBSCRIPTION_CHANGE_CANCEL,
  UNDO_SUBSCRIPTION_CANCELLATION,
  FTU_WALLET_BILLING_EDIT_CLICK,
  FTU_WALLET_BILLING_EDIT_SAVE,
  SURCHARGE_CONNECT_BANK_CLICK,
  PLAN_TRIAL_BANNER_DISMISS,
  PLAN_TRIAL_BANNER_UPGRADE_CLICK,
  PLAN_TRIAL_EXPIRED_BANNER_DISMISS,
  PLAN_TRIAL_EXPIRED_BANNER_UPGRADE_CLICK,
} from '../../../../constants/analytics-events';

export const PageEvents = {
  SUBSCRIPTION_CHANGE_START,
  SUBSCRIPTION_CHANGE_COMPLETE,
  SUBSCRIPTION_CHANGE_ERROR,
  SUBSCRIPTION_CHANGE_CANCEL,
  SUBSCRIPTION_CHANGE_SELECT_PLAN,
  SUBSCRIPTION_CHANGE_COMPARE_FEATURES_CLICK,
  SUBSCRIPTION_MIGRATION_TAB_SWITCH,
  ANNUAL_BILLING_TOGGLE,
  ADD_USER_CLICK,
  ADD_USER_CLICK_CONFIRM,
  FUND_SHIPSURANCE_CLICK,
  CONFIRM_FUND_SHIPSURANCE_CLICK,
  FUND_WALLET_CLICK,
  CONFIRM_FUND_WALLET_CLICK,
  MANAGE_AUTOFUND_CONFIG_CLICK,
  MANAGE_AUTOFUND_CONFIG_SAVE,
  UDPATE_RECURLY_BILLING_CLICK,
  UPDATE_RECURLY_BILLING_SAVE,
  UDPATE_WALLET_BILLING_CLICK,
  UPDATE_WALLET_BILLING_SAVE,
  ADD_VAT_ID_CLOSE,
  ADD_VAT_ID_CLICKED,
  ADD_VAT_ID_COMPLETE,
  ADD_VAT_ID_ERROR,
  UNDO_SUBSCRIPTION_CANCELLATION,
  FTU_WALLET_BILLING_EDIT_CLICK,
  FTU_WALLET_BILLING_EDIT_SAVE,
  SURCHARGE_CONNECT_BANK_CLICK,
  PLAN_TRIAL_BANNER_DISMISS,
  PLAN_TRIAL_BANNER_UPGRADE_CLICK,
  PLAN_TRIAL_EXPIRED_BANNER_DISMISS,
  PLAN_TRIAL_EXPIRED_BANNER_UPGRADE_CLICK,
};

export const PageEventSourceStrings = {
  LEGACY_SUBSCRIPTION_PAGE_CHANGE_SUBSCRIPTION_BUTTON: 'subscription-button',
  SUBSCRIPTION_CARD: 'subscription-card',
  ACCOUNT_ISSUES_BANNER: 'account-issues-banner',
  WALLET_BALANCE_CARD: 'wallet-balance-card',
  SHIPSURANCE_BALANCE_CARD: 'shipsurance-balance-card',
  PAYMENTS_TABLE: 'payments-table',
  TRIAL_COUNTDOWN_BANNER: 'trial-countdown-banner',
  TRIAL_COUNTDOWN_BANNER_BUTTON: 'trial-countdown-banner-button',
  PAYMENT_DUE_BANNER: 'payment-due-banner',
  UNDO_CANCELLATION_BANNER: 'undo-cancellation-banner',
  TAX_IDENTIFIER_MODAL: 'tax-identifier-modal',
  ADD_PAYMENT_METHOD_SUBSCRIPTION: 'add-payment-method-subscription',
  ADD_PAYMENT_METHOD: 'add-payment-method',
  EDIT_PAYMENT_METHOD: 'edit-payment-method',
  WALLET_REGISTRATION: 'wallet-registration',
  WALLET_UPDATE: 'wallet-update',
  PLAN_UPSELL_CAROUSEL: 'plan-upsell-carousel',
  SURCHARGE_BANNER: 'surcharge-banner',
  PLAN_TRIAL_BANNER: 'plan-trial-banner',
  PLAN_TRIAL_EXPIRED_BANNER: 'plan-trial-expired-banner',
  SHIPPY_ASSISTANT: 'shippy-assistant',
};

export const useTrackEvent = (eventName, source = '') => {
  const planInfo = useSelector(Global.selectSellerPlanInfo);

  return useCallback(
    (metadata = {}) => {
      const payload = {
        planCode: planInfo?.plan?.code,
        // The lift to convert a handful of tracking events off this flag would blow scope.
        // SPD-16505 to track final clean up of this.
        enablePaymentsAndSubscriptionSettings: true,
        ...metadata,
      };

      if (source) {
        payload.source = source;
      }

      Segment.trackEvent(eventName, payload);
    },
    [eventName, planInfo?.plan?.code, source],
  );
};
